/**
 * Turn technical / backend text into short student-facing copy.
 */

const DEFAULT_TITLES = {
  success: "Done",
  error: "Something went wrong",
  warning: "Please check",
  info: "Just so you know",
  primary: "Just so you know",
};

const TITLE_MAP = {
  "login failed": "Could not sign in",
  "signup failed": "Could not create account",
  "view failed": "Could not open",
  "compare failed": "Could not compare",
  "rollback failed": "Could not restore",
  "update failed": "Could not update",
  "delete failed": "Could not delete",
  "refine failed": "Could not update",
  "generation failed": "Could not generate",
  "upload failed": "Could not upload",
  "save failed": "Could not save",
};

function looksTechnical(s) {
  return /token|github|\.env|mongodb|mongoose|s3\b|aws\b|accessdenied|nosuchbucket|econn|enotfound|stack:|at Object\.|ENOENT|JWT|axios|status code|objectid|validation failed|EACCES|forbidden|AccessDenied|InvalidAccessKey|SignatureDoesNotMatch|schedules\/|version\(s\)|\.json\b/i.test(
    s
  );
}

export function friendlyNotice(raw, fallback = "") {
  const original = String(raw || "").trim();
  if (!original) return fallback;

  const lower = original.toLowerCase();

  if (/saved to db|saved in db|github|schedules\//i.test(original) && /saved/i.test(lower)) {
    return "Your schedule is saved. You can come back to it anytime.";
  }
  if (/cloud save failed|check you are logged in/i.test(original)) {
    return "Your plans are ready here. Sign in to keep them on your account.";
  }
  if (/no ai tokens|loaded from repository/i.test(original)) {
    return "We found a matching schedule, so you did not have to wait.";
  }
  if (/schedule adapted/i.test(original)) {
    return "Your schedule is ready and tailored to you.";
  }
  if (/plans generated|plan regenerated|plan polished/i.test(original)) {
    return original.replace(/plan regenerated!/i, "plan is ready.").replace(/plan polished!/i, "plan looks cleaner.");
  }
  if (/could not save|save to repository failed/i.test(original)) {
    return "We could not save your schedule. Please try again.";
  }
  if (/file upload failed|could not read that file/i.test(original)) {
    return "We could not read that file. Try another PDF or Word file.";
  }
  if (/generation failed|some plans failed|auto team schedule failed/i.test(original)) {
    return "We could not finish the schedule. Please try again.";
  }
  if (/session expired|invalid or expired token|token was invalid/i.test(original)) {
    return "Your session ended. Please sign in again.";
  }
  if (/network error|failed to fetch|econnrefused/i.test(original)) {
    return "We could not reach the server. Check your connection and try again.";
  }
  if (/too long|waking up|bad gateway|502|504/i.test(original)) {
    return "This is taking a little longer than usual. Wait a moment and try again.";
  }
  if (/accessdenied|invalidaccesskey|signaturedoesnotmatch|nosuchbucket/i.test(original)) {
    return "We could not store your file right now. Please try again in a moment.";
  }
  if (/unknown error/i.test(original)) {
    return "Please try again in a moment.";
  }

  let s = original.replace(/\s+/g, " ").trim();
  s = s
    .replace(/schedules\/[^\s]+/gi, "")
    .replace(/GITHUB_TOKEN[^.]*\.?/gi, "")
    .replace(/backend\/\.env/gi, "")
    .replace(/\b(mongodb|mongo|github|JWT|API|S3|AWS)\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .replace(/^[,·\-–—.\s]+|[,·\-–—.\s]+$/g, "")
    .trim();

  if (!s || looksTechnical(s) || s.length > 180) {
    return fallback || "Please try again in a moment.";
  }
  return s;
}

export function friendlyTitle(raw, type = "info") {
  const s = String(raw || "").trim();
  if (!s) return DEFAULT_TITLES[type] || DEFAULT_TITLES.info;
  const mapped = TITLE_MAP[s.toLowerCase()];
  if (mapped) return mapped;
  if (looksTechnical(s)) return DEFAULT_TITLES[type] || DEFAULT_TITLES.info;
  return s;
}

export function defaultNoticeTitle(type) {
  return DEFAULT_TITLES[type] || DEFAULT_TITLES.info;
}
